'use client';

import { motion, useInView } from 'framer-motion';
import { type HTMLProps, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface TypingEffectProps extends Omit<HTMLProps<HTMLHeadingElement>, 'children'> {
	text: string;
	once?: boolean;
}
export function TypingEffect({ text = 'Typing Effect', once = false, className, ...rest }: TypingEffectProps) {
	const ref = useRef(null);
	const isInView = useInView(ref, { once });

	return (
		<h1 ref={ref} className={twMerge('z-20 font-dm_sans font-medium', className)} {...rest}>
			{text.split('').map((letter, index) => (
				<motion.span
					key={index}
					initial={{ opacity: 0 }}
					animate={isInView ? { opacity: 1 } : {}}
					transition={{ duration: 0.1, delay: isInView ? index * 0.1 : 0 }}
				>
					{letter}
				</motion.span>
			))}
		</h1>
	);
}
